import React from 'react';
import { DomainNs } from 'ReactApp/Types/DomainNs';
import { observer } from "mobx-react";
import { motion } from 'framer-motion';
import { CommonLabelsEnum } from 'ReactApp/Types/enum';
import { priceFormatter } from 'ReactApp/Services/Formatters/PriceFormatter';
import splitLine from 'ReactApp/Services/MotionHelpers/SplitLine';

const sentence = {
    visible: {
        transition: {
            delay: 1,
            staggerChildren: 0.05,
            staggerDirection: 1,
        },
    },
}

type PriceBlockV2Props = {
    salePrice: DomainNs.PriceFieldInterface | null
    oldPrice: DomainNs.PriceFieldInterface | null,
    isGift?: boolean,
}

const PriceBlockV2 = observer((props: PriceBlockV2Props) => {

    if (props.salePrice === null) {
        return (
            <>
                <motion.div
                    className='sale-price-v1'
                    variants={sentence}
                    initial="hidden"
                    animate="visible"
                >
                    {splitLine(CommonLabelsEnum.productHasNoPrice)}
                </motion.div>
            </>
        );
    }

    function renderOldPrice() {
        if (typeof props.oldPrice?.value === 'number') {
            return (
                <div className="old-price-v1">
                    <span className="old-price-v1__label">Цена: </span>
                    <motion.span
                        className='old-price-v1__value'
                        variants={sentence}
                        initial="hidden"
                        animate="visible"
                    >
                        {splitLine(priceFormatter.format(
                            Number(props.oldPrice.value)
                        ))}
                    </motion.span>
                </div>
            );
        }
    }

    return (
        <>
            {props.oldPrice?.value !== null && renderOldPrice()}
            <motion.div
                className='sale-price-v1'
                variants={sentence}
                initial="hidden"
                animate="visible"
            >
                {splitLine(
                    (props.isGift === true)
                        ? CommonLabelsEnum.productAsGift
                        : priceFormatter.format(props.salePrice.value)
                )}
            </motion.div>
        </>
    );

})

export default PriceBlockV2;